import React from "react";
import { newContextComponents } from "@drizzle/react-components";
import DisplayedWeiData from '../DisplayedWeiData'

import { Web3StatusContext } from "../../contexts/Web3StatusContext";

const { AccountData, ContractData, ContractForm } = newContextComponents;

class WithdrawFunds extends React.Component {
  static contextType = Web3StatusContext;

  state = { 
    inputBNB: 0,
    stackId: -1,
  };

  activeAccount = null;

  myChangeHandler = (event) => {
    let { value } = event.target;
    
    var bnbAmount = value;
    this.setState({inputBNB: bnbAmount});
  }

  mySubmitHandler = (event) => {
    event.preventDefault();
    if(this.context.activeAccount == null) {
      console.log('no active account to approve');
      return;
    }
    const { drizzle } = this.props;
    const { GAMEFORESTSale } = drizzle.contracts;

    var stackId;
    if(this.state.inputBNB <= 0)
      stackId = GAMEFORESTSale.methods.beneficiaryWithdraw.cacheSend();
    else {
      var parameter = this.context.web3.utils.toWei(this.state.inputBNB.toString(), "ether");
      stackId = GAMEFORESTSale.methods.beneficiaryWithdraw.cacheSend(parameter);
    }
    this.setState({ stackId: stackId });
  }

  render() {

    const { GAMEFORESTSale } = this.props.drizzleState.contracts;

    return (
      <div>
          <form onSubmit={this.mySubmitHandler}>
            <input
                type="number"
                value={this.state.inputBNB}
                onChange={this.myChangeHandler}
              />
              <br/>
            <input
            type='submit'
            value="Withdraw BNB Funds"
            />
          </form>
      </div>
    );
  }
};

export default WithdrawFunds;